import { useTheme } from "@emotion/react";
import {
  CommentOutlined,
  DoneAllOutlined,
  StarBorderOutlined,
} from "@mui/icons-material";
import {
  Autocomplete,
  Checkbox,
  Chip,
  createFilterOptions,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { v4 as uuidv4 } from "uuid";
import { Box } from "@mui/system";
import useStyles from "./styles";
import { useEffect, useState } from "react";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

export default function AnswerComponent(params) {
  const {
    id,
    question = {},
    position = 0,
    error = false,
    handleQuestionChange = () => {},
  } = params;
  const theme = useTheme();
  const styles = useStyles(theme);

  const [type, setType] = useState(question?.type || 0);
  const [value, setValue] = useState(question?.options || []);
  const [optionsAutocomplete, setOptionAutocomplete] = useState(
    question?.options || []
  );
  const handleChange = (event) => {
    if (event.target.value !== 2) {
      setValue([]);
    }

    handleQuestionChange(id, "type", event.target.value);
    setType(event.target.value);
  };
  const filter = createFilterOptions();
  useEffect(() => {
    handleQuestionChange(id, "position", position);
  }, []);

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  useEffect(() => {
    handleQuestionChange(id, "options", value);
  }, [value]);

  return (
    <Paper variant="outlined" elevation={0} sx={styles.paperComponent}>
      <TextField
        sx={{ width: "100%", height: "100%" }}
        variant="filled"
        label="Pergunta"
        multiline
        rows={2}
        value={question?.question}
        error={!question?.question?.trim() && error}
        helperText={
          !question?.question?.trim() && error ? "Pergunta é obrigatória" : ""
        }
        onChange={(event) =>
          handleQuestionChange(id, "question", event.target.value)
        }
      />
      <Box sx={styles.boxTypeResposta}>
        <FormControl fullWidth>
          <InputLabel sx={{ top: 10 }} id="demo-simple-select-label">
            Tipo de resposta
          </InputLabel>
          <Select
            variant="filled"
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={type}
            label="Tipo de resposta"
            onChange={handleChange}
            size="small"
          >
            <MenuItem value={0}>
              <Box sx={styles.containerMenuItem}>
                <StarBorderOutlined
                  sx={{ color: theme.palette.colors.yellow.dark }}
                />
                <Typography>Nota de avaliação</Typography>
              </Box>
            </MenuItem>

            <MenuItem value={1}>
              {" "}
              <Box sx={styles.containerMenuItem}>
                <CommentOutlined
                  sx={{ color: theme.palette.colors.blue.medium }}
                />
                <Typography>Comentário livre</Typography>
              </Box>
            </MenuItem>
            <MenuItem value={2}>
              {" "}
              <Box sx={styles.containerMenuItem}>
                <DoneAllOutlined
                  sx={{ color: theme.palette.colors.green.light }}
                />
                <Typography>Caixa de seleção</Typography>
              </Box>
            </MenuItem>
          </Select>
        </FormControl>
        {type === 2 && (
          <Autocomplete
            multiple
            freeSolo
            options={optionsAutocomplete}
            getOptionLabel={(option) =>
              typeof option === "string" ? option : option.option
            }
            size="small"
            value={value}
            isOptionEqualToValue={(opt, val) =>
              opt?.option?.toLowerCase() === val?.option?.toLowerCase()
            }
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {typeof option === "string" ? option : option.option}
              </li>
            )}
            onChange={(event, newValue, reason) => {
              if (reason === "removeOption") {
                setValue(newValue);
                return;
              }

              const lastItem = newValue[newValue.length - 1];

              let inputValue = "";

              if (typeof lastItem === "string") {
                if (lastItem.startsWith("Criar '") && lastItem.endsWith("'")) {
                  inputValue = lastItem.slice(7, -1).trim();
                } else {
                  inputValue = lastItem.trim();
                }
              } else {
                inputValue = lastItem?.option?.trim();
              }

              if (!inputValue) {
                return;
              }

              const jaExiste = optionsAutocomplete.find(
                (opt) =>
                  opt?.option?.toLowerCase() === inputValue?.toLowerCase()
              );

              const jaSelecionado = value.find(
                (v) => v?.option?.toLowerCase() === inputValue?.toLowerCase()
              );

              if (jaSelecionado) {
                setValue(
                  value.filter(
                    (v) =>
                      v?.option?.toLowerCase() !== inputValue?.toLowerCase()
                  )
                );
              } else if (jaExiste) {
                setValue([...value, jaExiste]);
              } else {
                const novoItem = {
                  id: uuidv4(),
                  option: inputValue?.trim(),
                };

                setOptionAutocomplete((prev) => [...prev, novoItem]);
                setValue([...value, novoItem]);
              }
            }}
            filterOptions={(opts, params) => {
              const filtered = filter(opts, params);
              const input = params.inputValue.trim();

              if (
                input !== "" &&
                !opts.some(
                  (opt) => opt?.option?.toLowerCase() === input?.toLowerCase()
                )
              ) {
                filtered.push(`Criar '${input}'`);
              }

              return filtered;
            }}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Tooltip title={option.option} key={option.id}>
                  <Chip
                    variant="outlined"
                    label={option.option}
                    {...getTagProps({ index })}
                  />
                </Tooltip>
              ))
            }
            renderInput={(params) => (
              <TextField
                error={error && value.length === 0}
                helperText={
                  error && value.length === 0 ? "Opções são obrigatórias" : ""
                }
                variant="filled"
                {...params}
                label="Opções de seleção"
                placeholder="Adicionar"
                autoComplete="off"
                sx={{
                  "& .MuiInputBase-root": {
                    paddingTop: "20px",
                  },
                  "& .MuiInputLabel-root": {
                    top: "-3px",
                  },
                }}
              />
            )}
          />
        )}
      </Box>
    </Paper>
  );
}
